import { IsDefined, IsInt, IsString, Length } from 'class-validator';

export class BillingChannelTypeReplaceDto {
  @IsDefined()
  @IsInt()
  id: number;

  @IsDefined()
  @IsString()
  @Length(0, 150)
  name: string;
}